import type { FormProps } from 'antd/lib/form/Form';

export const layoutFormProps: FormProps = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
